var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerScratchSugarIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5496 9.12516C30.5681 10.474 33.0324 12.8178 34.5308 15.7649C36.0291 18.712 36.4709 22.0841 35.7822 25.3177C35.0935 28.5514 33.3161 31.4508 30.7469 33.5317C28.1777 35.6125 24.9723 36.7488 21.6661 36.7507C18.8378 36.7509 16.0717 35.9203 13.7113 34.3622C11.3508 32.804 9.50007 30.5869 8.38875 27.986C7.27743 25.3852 6.95451 22.5152 7.46008 19.7324C7.96565 16.9496 9.27745 14.3766 11.2326 12.3329C12.5791 14.215 14.3564 15.7475 16.4161 16.8024C16.4522 14.49 16.998 12.214 18.0147 10.1368C19.0314 8.05959 20.4939 6.23227 22.2978 4.78516C23.6747 6.63174 25.4753 8.12024 27.5478 9.12516H27.5496Z",
    stroke: "url(#paint0_linear_6578_38235)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6655 31.4987C23.3328 31.5014 24.9385 30.8695 26.1567 29.7313C27.3749 28.593 28.1142 27.0338 28.2245 25.3702C28.3348 23.7067 27.8077 22.0635 26.7504 20.7744C25.6931 19.4853 24.1848 18.647 22.5318 18.4297C20.7247 20.0468 19.5342 22.2405 19.163 24.6369C17.8149 24.3066 16.5459 23.7111 15.4303 22.8852C15.106 23.871 15.02 24.9197 15.1796 25.9452C15.3392 26.9706 15.7396 27.9436 16.3482 28.7843C16.9567 29.625 17.756 30.3093 18.6803 30.7812C19.6047 31.253 20.6277 31.4989 21.6655 31.4987Z",
    stroke: "url(#paint1_linear_6578_38235)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38235",
    x1: 12.0119,
    y1: 17.4468,
    x2: 44.078,
    y2: 40.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6578_38235",
    x1: 17.2786,
    y1: 23.6063,
    x2: 30.7852,
    y2: 34.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerScratchSugarIcon3);
export default __webpack_public_path__ + "static/media/jokerScratchSugarIcon3.2b30de8bfdc3bda62bcdd457748c635a.svg";
export { ForwardRef as ReactComponent };